import {
  type Time,
  ColorType,
  type ChartOptions,
  type ChartOptionsBase,
  type DeepPartial,
  type CreatePriceLineOptions
} from 'lightweight-charts'

export const getChartOptions = (backgroundColor?: string): Partial<ChartOptionsBase> => ({
  layout: {
    textColor: '#AAB3BB',
    background: {
      type: ColorType.Solid, // ColorType.VerticalGradient,
      color: backgroundColor || '#1E222D'
    },
    fontSize: 12,
    fontFamily: 'Arial, sans-serif',
    attributionLogo: false,
    colorParsers: [],
    colorSpace: 'srgb',
    panes: {
      enableResize: false,
      separatorColor: '#AAB3BB',
      separatorHoverColor: '#AAB3BB'
    }
  },

  autoSize: true,
  // height: 100
})

// Для обратной совместимости
export const chartOptions: Partial<ChartOptionsBase> = getChartOptions()

export const legendStyle = {
  color: '#8AB7FF',
  style: `position: absolute; left: 10px; top: 10px; z-index: 1; font-size: 14px; font-family: sans-serif; line-height: 18px; font-weight: 300;`
}

export const priceLineDefaultConf: CreatePriceLineOptions = {
  price: 0,
  color: '#3179F5',
  lineWidth: 2,
  lineStyle: 2, // LineStyle.Dashed
  axisLabelVisible: true,
  title: 'my label'
}

const tickMarkFormatter = (time: Time) => {
  const date = new Date((time as number) * 1000)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}
export const initialOptions: DeepPartial<ChartOptions> = {
  kineticScroll: {
    touch: true,
    mouse: true
  },

  handleScale: false,
  // handleScroll: false,
  timeScale: {
    tickMarkFormatter,
    // lockVisibleTimeRangeOnResize: true
    // shiftVisibleRangeOnNewBar: false
    // enableConflation: true
    // fixLeftEdge: true,
    // fixRightEdge: true,
    rightOffset: 20
  },
  rightPriceScale: {
    scaleMargins: {
      top: 0.2, // leave some space for the legend
      bottom: 0.05
    }
  },
  crosshair: {
    // hide the horizontal crosshair line
    horzLine: {
      visible: false,
      labelVisible: false
    }
  },
  // hide the grid lines
  grid: {
    vertLines: {
      visible: false
    },
    horzLines: {
      visible: false
    }
  }
}
